module.exports = __webpack_public_path__ + "static/media/ka1.63eba5d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/libs/fonts/ka1.ttf
// module id = 157
// module chunks = 0